import { Users } from "../modules";

export const DomiciliariosPage = () => {
  return <Users variant="domiciliarios" />;
};
